import { Box, Flex, retriever } from '@retriever-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useWindowWidth } from 'src/store/context/window.context'

const Videos = () => {
  const { t } = useTranslation('landing-pages/growth')
  const { windowWidth } = useWindowWidth()
  return (
    <Flex
      direction="column"
      alignItems="center"
      mBottom={[50, 120]}
      padding={['60px 20px', '80px 40px']}
      backgroundImage={`url("${process.env.REACT_APP_CDN_IMAGE}/https://housi-images.s3.amazonaws.com/site/lp-decor/backgrounds/black-new.png")`}
    >
      <Box mBottom={[40, 60]}>
        <retriever.p
          fontSize="32px"
          fontWeight="bold"
          color="black.500"
          textAlign={['initial', 'center']}
        >
          {t('landing-pages/growth:videos.TITLE.0')}
        </retriever.p>
        <retriever.p
          fontSize="32px"
          fontWeight="bold"
          color="black.500"
          textAlign={['initial', 'center']}
        >
          {t('landing-pages/growth:videos.TITLE.1')}
        </retriever.p>
      </Box>
      <Flex
        direction={['column', 'row']}
        flexWrap="wrap"
        width={['100%', '1500px']}
        justifyContent="center"
        gap="24px"
        p={['0 20px', '0 127px']}
      >
        <iframe
          width={windowWidth > 720 ? '544' : '100%'}
          height={windowWidth > 720 ? '300' : '186'}
          src="https://www.youtube.com/embed/DiqokDrdgHw"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        <iframe
          width={windowWidth > 720 ? '544' : '100%'}
          height={windowWidth > 720 ? '300' : '186'}
          src="https://www.youtube.com/embed/mYXG7rQOxfc"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        <iframe
          width={windowWidth > 720 ? '544' : '100%'}
          height={windowWidth > 720 ? '300' : '186'}
          src="https://www.youtube.com/embed/iLvx4ZNY4As"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Flex>
    </Flex>
  )
}

export default Videos
